import { useWaitForObservedElement } from './useWaitForObservedElement';
import { watchEffect } from 'vue';

export function useScrollToIdWhenPresent(elementId: string) {
  const el = useWaitForObservedElement(elementId);
  watchEffect(() => {
    if (el.value) el.value.scrollIntoView({ behavior: 'smooth' }); // Scroll to element when appearing in DOM
  });
}
